import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";

type Props = {
  message?: string;
  isRedirect?: boolean;
};

export function AccessDenied({ message, isRedirect }: Props) {
  return (
    <Alert status={isRedirect ? "info" : "error"}>
      <AlertIcon />
      <AlertTitle>{isRedirect ? "Redirecting" : "Access Denied"}</AlertTitle>
      <AlertDescription>
        {" "}
        {message !== undefined
          ? message!
          : "You don't have access to this page"}
      </AlertDescription>
    </Alert>
  );
}
